/**
 * This file is part of an epic that is currently on hold and is not being used in the application.
 * Please refer to the README.md file in the root of the PDFRenderer directory for more information.
 */

/**
 * Converts pixels to points. Helps with pixel-based designs being reflected in PDFs.
 *
 * This function takes a number of pixels and converts it to points.
 * Points are a unit of length, commonly used in typography.
 * One point is equal to 1/72 of an inch.
 * On the other hand, in digital media, one pixel is equal to 1/96 of an inch.
 * Therefore, to convert pixels to points, we multiply the number of pixels by the ratio of points to pixels (72/96).
 */
export const pixelsToPoints = (pixels: number) => {
	return pixels * (72 / 96);
};
